import { Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import CommonPagination from "components/CommonPagination";
import GKTable from "components/GKTable";
import axiosInstance from "utils/axiosInstance";

const ClientsTable = () => {
  const {
    state: { commonFilter },
  } = useAppContext();

  const requestBody = {
    take: commonFilter?.clientList?.take,
    skip: commonFilter?.clientList?.skip,
    sort: JSON.stringify(
      commonFilter?.clientList?.sortModel?.map((data) => {
        return {
          selector: data.field,
          desc: data.sort !== "asc",
        };
      })
    ),
    search: commonFilter?.clientList?.search || "",
  };

  const { data, isFetching } = useQuery({
    queryKey: ["DASHBOARD_CLIENT_TABLE", requestBody],
    queryFn: () =>
      axiosInstance.get(`/super_admin/clients/`, { params: requestBody }),
  });

  const cusPagination = () => {
    return (
      <CommonPagination
        name="clientList"
        totalCount={data?.data?.totalCount || 0}
      />
    );
  };

  const columns = [
    {
      headerName: "Client Name",
      field: "name",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Phone Number",
      field: "phone",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
      type: "number",
    },
    // {
    //   headerName: "Company Name",
    //   field: "companyName",
    //   disableColumnMenu: true,
    //   flex: 1,
    //   minWidth: 150,
    //   valueGetter: (row) => row || "-",
    // },
    {
      headerName: "KYC Status",
      field: "kycStatus",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Risk Profile",
      field: "riskScore",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Created on",
      field: "createdOn",
      disableColumnMenu: true,
      flex: 1,
      minWidth: 150,
    },
    // {
    //   headerName: "Advisor",
    //   field: "advisor",
    //   disableColumnMenu: true,
    //   flex: 1,
    //   minWidth: 150,
    //   valueGetter: (row) => row || "-",
    // },
  ];

  return (
    <Grid container spacing={4}>
      {/* <Grid
        item
        xs={12}
        display={"flex"}
        justifyContent={"space-between"}
      ></Grid> */}
      <Grid item xs={12}>
        <GKTable
          loading={isFetching}
          columns={columns}
          rows={data?.data?.data || []}
          maxHeight={"calc(100vh - 250px)"}
          searchPlaceholder="Search for client"
          CustomPagination={!isFetching && cusPagination}
          filterButton={false}
          name="clientList"
          tableName="client_list"
        />
      </Grid>
    </Grid>
  );
};

export default ClientsTable;
